<template>
	<b-button @click="emitClick" :disabled="disabled" :size="size" :variant="variant" :style="style">
		{{ text }}
		<slot name="content"></slot>
	</b-button>
</template>

<script>
export default {
	props: {
		text: { type: String },
		variant: { type: String },
		disabled: { type: Boolean },
		size: { type: String, default: "md" },
		style: { type: String }
	},
	methods: {
		emitClick: function (e) {
			this.$emit("click", e);
		}
	}
};
</script>
